import React, { useState, useEffect, useRef } from "react";
import { Formik, Field } from "formik";
import * as Yup from "yup";
import axios from "axios";
import BasicCard from "../BasicCard";
import Dummylayout from "../Dummylayout";
import Modal from "react-bootstrap/Modal";
import { useSearchParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Button from "react-bootstrap/Button";
import ProgressBar from "react-bootstrap/ProgressBar";
import * as ReactBootstrap from "react-bootstrap";
import { Toast, ToastContainer } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { baseURL } from "../../config";

function calculateTotalMarks(marks) {
  if (!marks || marks.length === 0) return 0; // If marks is undefined or empty, return 0
  if (marks.length === 1) return parseInt(marks[0], 10);

  return marks.reduce(
    (total, mark) => total + (mark ? parseInt(mark, 10) : 0),
    0
  );
}

function openModalWithButton(employeeid) {
  // Define your modal logic here
  // For example, you could use a library like react-modal to create a modal
  // with a button that redirects to the PIP page
}

function AppraisalTeamMember() {
  const [employee, setEmployee] = useState([]);
  const [options, setOptions] = useState([]);
  const [subcat, setSubcat] = useState([]);
  const [grade, setGrade] = useState([]);
  const [total, setTotal] = useState([]);
  const [totalcatval, setTotalCatval] = useState([]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [ispipModelOpen, setpipModalOpen] = useState(false);
  const [formData, setFormData] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [showLabel, setShowLabel] = useState(false);
  const [attendanceOptions, setAttendanceOptions] = useState(false);
  const [performanceeOptions, setPerformanceOptions] = useState(false);
  const [categoryOptions, setCategoryOptions] = useState(false);
  const [kpiOptions, setKPIOptions] = useState([]);
  const [subkpiOptions, setSubKPIOptions] = useState(false);
  const [warningText, setWarningText] = useState("");
  const [attsubtotal, setAttSubtotal] = useState(0);
  const [approval, setApproval] = useState(null);
  const [appeal, setAppeal] = useState(null);
  const [approvalDate, setApprovalDate] = useState(null);
  const [appeallDate, setAppeallDate] = useState(null);
  const [sectionTotal, setSectionTotal] = useState(null);
  const [trainingComment, setTrainingComment] = useState(null);
  const [generalComment, setGeneralComment] = useState(null);
  const [categoryMapvalues, setCategoryMapvalues] = useState(null);
  const [posts, setPosts] = useState({ smartgoals: [] });
  const [expandedRow, setExpandedRow] = useState(null);
  const [postsSub, setPostsSub] = useState({ subgoals: [] });
  const [isKpiWeightageIncluded, setIsKpiWeightageIncluded] = useState(false);
  const [KPIWeightage, setKPIWeightage] = useState(0);
  const [apprQuestionsWeightage, setApprQuestionsWeightage] = useState(0);
  const [smartKPITotal, setSmartKPITotal] = useState(0);
  const [subKPITotal, setSubKPITotal] = useState(0);
  const [primaryCategoryName, setPrimaryCategoryName] = useState("");
  const [totVal, setTotVal] = useState(0);
  const [totalQuestions, setTotalQuestions] = useState(0);
  const [categorySubtotal, setCaegorytSubtotal] = useState(0);
  const [subcategoriesMap, setSubcategoriesMap] = useState({});

  useEffect(() => {
    if (!categoryMapvalues) return;

    const fetchAll = async () => {
      const tempMap = {};

      for (const [categoryId] of Object.entries(categoryMapvalues)) {
        const res = await axios.get(
          `${baseURL}/getsubcategorieforcatid?parentid=${categoryId}`
        );

        tempMap[categoryId] = res.data.subcategories;
      }

      setSubcategoriesMap(tempMap);
    };

    fetchAll();
  }, [categoryMapvalues]);

  const getSubcategoryName = (parentId, subcatId) => {
    const list = subcategoriesMap[parentId];
    if (!list) return subcatId; // fallback if loading

    const found = list.find((item) => item.id == subcatId);
    return found ? found.subcategoryname : subcatId;
  };

  const navigate = useNavigate();
  const usernameRef = useRef(null);

  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(0);

  let deptid = localStorage.getItem("departmentid");
  let currentuserid = localStorage.getItem("employeeid");

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [perfmarks, setPefMarks] = useState(
    Array(performanceeOptions.length).fill("")
  );
  const [attmarks, setAttarks] = useState(
    Array(attendanceOptions.length).fill("")
  );
  const [catmarks, setCatmarks] = useState(
    Array(categoryOptions.length).fill("")
  );
  const [periodmonth, setPeriodMonth] = useState("");
  const [periodyear, setPeriodYear] = useState("");
  const [catSubtotal, setCatSubtotal] = useState(null);
  const [showToast, setShowToast] = useState(false);

  const id = searchParams.get("id");
  const appraisalmonth = searchParams.get("mon");
  const appraisalyear = searchParams.get("yr");
  const period = appraisalmonth + appraisalyear;
  const username = localStorage.getItem("username");
  const role = localStorage.getItem("userrole");
  const countOfSmartGoals = posts.smartgoals.length;
  const [smartkpiMarks, setSmartKpiMarks] = useState(
    Array(kpiOptions.length).fill("")
  );
  const [subkpiMarks, setsubKpiMarks] = useState(
    Array(subkpiOptions.length).fill("")
  );
  let currentDate = new Date();

  let totals = 0;
  const [initialValues, setInitialValues] = useState({
    smartkpi: [],
    subkpi: [],

    total: 0,
  });
  const userid = localStorage.getItem("userid");
  const eid = localStorage.getItem("employeeid");
  const formatDate = (dateString) => {
    const options = { day: "2-digit", month: "long", year: "numeric" };
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", options);
  };

  currentDate = formatDate(currentDate);
  const openModalWithButton = (employeeid) => {
    //    alert(employeeid);
    // window.location.href='/pippage?id='+employeeid;
    // Define your modal logic here
    // For example, you could use a library like react-modal to create a modal
    // with a button that redirects to the PIP page
  };
  // const handlePIPConfirm   =() =>
  // {
  //     // alert("inside handlePIP Confirm  - Employeeid= " +employee)
  //     window.location.href='/initiatepip?id='+employee;
  // }
  const calculateKPITotalMarks = () => {
    let total = 0;
    for (let i = 0; i <= countOfSmartGoals; i++) {
      const input = document.querySelector(
        `input[name="smartgoals[${i}].marks"]`
      );

      if (input && input.value) {
        total += Number(input.value);
      }
    }
    setSmartKPITotal(total);
    return total;
  };

  const calculateSubKPITotalMarks = () => {
    let total = 0;
    for (let i = 0; i <= 10; i++) {
      const input = document.querySelector(
        `input[name="subgoals[${i}].marks"]`
      );
      console.log(input, "SUBKPI TOTAL MARKS");
      if (input && input.value) {
        total += Number(input.value);
      }
    }
    setSubKPITotal(total);
    return total;
  };

  const calculateFinalTotal = () => {
    let totalSum = 0;

    // Select all input fields with a name attribute ending in ".total"
    const totalInputs = document.querySelectorAll('input[name$=".total"]');

    totalInputs.forEach((input) => {
      // Convert the input value to a number and add it to the total sum
      const value = parseFloat(input.value) || 0;
      totalSum += value;
    });
    return totalSum;
  };

  // const handleConfirm = async () => {
  //     try {
  //         // const json =JSON.stringify(formData);
  //         //alert(json);
  //         const templateData = {
  //             questions: formData
  //         };
  //         const myHeaders = new Headers();
  //         myHeaders.append("Content-Type", "application/json");
  //         const json = JSON.stringify(templateData);
  //         const requestOptions = {
  //             method: "POST",
  //             headers: myHeaders,
  //             body: json,
  //             redirect: "follow"
  //         };
  //         const response = fetch('http://localhost:3050/addappraisal?id=' + id, requestOptions);

  //         if (response.status === 200) {
  //             setFormData(null);
  //             setIsModalOpen(false);
  //             addNotification();
  //             if (formData.totalmarks < 60) {
  //                 let employeeid = formData.employeeid;
  //                 // Open modal box with button that redirects to PIP page
  //                 // Example using a hypothetical function openModalWithButton:
  //                 openModalWithButton(employeeid);
  //             } else {
  //                 // Redirect to myteamappraisal page
  //                 window.location.href = "/myteamappraisal";
  //             }
  //         }
  //          else {
  //             console.error('Form submission failed:', response.statusText);
  //         }
  //     } catch (error) {
  //         console.error("An error occurred:", error);
  //     }
  // };
  // Define the getProgressColor function
  const getProgressColor = (progress) => {
    if (progress <= 30) {
      return "danger";
    } else if (progress <= 60) {
      return "warning";
    } else {
      return "success";
    }
  };

  const getSubKPI = async (empid) => {
    try {
      const { data } = await axios(`${baseURL}/getsubgoals?eid=` + empid);
      if (Array.isArray(data.subgoals)) {
        setPostsSub({ subgoals: data.subgoals });
      } else {
        console.error("Data is not an array:", data);
      }
    } catch (error) {
      console.error("Error fetching posts:", error);
    }
  };
  const getKPIForuser = async (empid) => {
    try {
      //alert(empid);
      let strAPI =
        `${baseURL}/getkpiforappraisalperiod?assignee=` +
        empid +
        "&mon=" +
        appraisalmonth +
        "&year=" +
        appraisalyear;
      const { data } = await axios.get(strAPI);
      setPosts({ smartgoals: data?.smartgoals });
    } catch (error) {
      console.error("Error fetching posts:", error);
    }
  };

  const handleConfirm = async () => {
    try {
      let isSupervisor = role === "ROLE_SUPERVISOR" ? "1" : "0";

      const payload = {
        id: id,
        total: formData.totalmarks,
        period: period,
        tc: trainingComment,
        gc: generalComment,
        supervisor: isSupervisor,
        questions: formData,
      };

      const response = await fetch(`${baseURL}/addappraisal`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        setFormData(null);
        setIsModalOpen(false);
        addNotification(id);
        navigate("/myteamappraisal");
      } else {
        const err = await response.text();
        console.error("Form submission failed:", err);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  const handleKPIChange = (e, smartgoalId) => {
    const newValue = parseInt(e.target.value, 10);
    if (isNaN(newValue)) return; // Handle invalid input gracefully
    const kpis = {
      id: smartgoalId,
      val: newValue,
    };
    let t1 = calculateSubKPITotalMarks();
    let t2 = calculateKPITotalMarks();
    if (parseInt(t1 + t2) > parseInt(KPIWeightage)) {
      alert(
        "KPI Total marks exceeds KPI Weightage value of " +
          KPIWeightage +
          "\n Try reducing the marks for kpis"
      );
      setWarningText(
        "The Total Weightage for Appraisal questions is more..Please reduce the marks to set it below the weightage.."
      );
    }
    setKPIOptions((prevKPIOptions) => {
      // Ensure prevKPIOptions is always an array
      const optionsArray = Array.isArray(prevKPIOptions) ? prevKPIOptions : [];

      const existingKPIIndex = optionsArray.findIndex(
        (kpi) => kpi.id === smartgoalId
      );

      if (existingKPIIndex !== -1) {
        // If it exists, update the existing KPI value
        const updatedKPIOptions = [...optionsArray];
        updatedKPIOptions[existingKPIIndex] = kpis;
        return updatedKPIOptions;
      } else {
        // If it doesn't exist, add the new KPI to the array
        return [...optionsArray, kpis];
      }
    });
  };

  const handleSubKPIChange = (e, subgoalId) => {
    const newValue = parseInt(e.target.value, 10);
    if (isNaN(newValue)) return; // Handle invalid input gracefully
    const kpis = {
      id: subgoalId,
      val: newValue,
    };
    let t1 = calculateSubKPITotalMarks();
    let t2 = calculateKPITotalMarks();
    if (parseInt(t1 + t2) > parseInt(KPIWeightage)) {
      alert(
        "KPI Total marks exceeds KPI Weightage value of " +
          KPIWeightage +
          "\n Try reducing the marks for kpis"
      );
    }

    setSubKPIOptions((prevKPIOptions) => {
      // Ensure prevKPIOptions is always an array
      const optionsArray = Array.isArray(prevKPIOptions) ? prevKPIOptions : [];

      const existingKPIIndex = optionsArray.findIndex(
        (kpi) => kpi.id === subgoalId
      );

      if (existingKPIIndex !== -1) {
        // If it exists, update the existing KPI value
        const updatedKPIOptions = [...optionsArray];
        updatedKPIOptions[existingKPIIndex] = kpis;
        return updatedKPIOptions;
      } else {
        // If it doesn't exist, add the new KPI to the array
        return [...optionsArray, kpis];
      }
    });
  };

  const addNotification = async (id) => {
    try {
      const response = await axios.get(`${baseURL}/addnotification?eid=` + id);
      const data = response.data;
      if (response.status === 200) {
      } else {
        console.error("Form submission failed:", response.statusText);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };
  const handleSubmit = async (values) => {
    console.log("values", values);
    const categoryQuestionsWithValues = {}; // Object to store questions by category (e.g., questions44, questions45)

    // Loop over the `values` entries to dynamically build question arrays
    Object.entries(values).forEach(([key, value]) => {
      if (key.startsWith("questions") && Array.isArray(value)) {
        // Extract the category name from the key, e.g., "questions44" -> "44"
        const categoryKey = key;
        console.log("categoryKey", categoryKey);

        // const catid = categoryKey?.substring(categoryKey.length - 2);
        // console.log("catid", catid);

        const match = categoryKey && categoryKey.match(/(\d+)$/);
        const catid = match ? match[1] : null;
        console.log("catid", catid);

        // Ensure categoryMapvalues[categoryKey] exists and is an array
        if (
          categoryMapvalues[catid] &&
          Array.isArray(categoryMapvalues[catid])
        ) {
          // Map each question with additional data
          const questionsArray = value.map((question, idx) => ({
            question: categoryMapvalues[catid][idx]?.text || "", // Provide default value if undefined
            category: categoryMapvalues[catid][idx]?.category || "",
            subcategory: categoryMapvalues[catid][idx]?.subcategory || "",
            rating: categoryMapvalues[catid][idx]?.rating || 0,
            marks: question?.marks || 0, // Use the user-entered marks or 0 as default
            comments: question?.comments || "", // Add comments field if needed
          }));

          // Assign the array to the category-specific key
          categoryQuestionsWithValues[categoryKey] = questionsArray;
        } else {
          console.warn(
            `Category key ${categoryKey} is missing or invalid in categoryMapvalues.`
          );
        }
      }
    });

    // Optional KPI and SubKPI handling (if you have this part in the original setup)
    let kpiValues = [];
    if (Array.isArray(kpiOptions) && kpiOptions.length > 0) {
      kpiValues = kpiOptions.map((kpiOption) => ({
        id: kpiOption.id,
        val: kpiOption.val,
      }));
    }
    let subkpiValues = [];
    if (Array.isArray(subkpiOptions) && subkpiOptions.length > 0) {
      subkpiValues =
        subkpiOptions?.map((subkpiOption) => ({
          id: subkpiOption.id,
          val: subkpiOption.val,
        })) || [];
    }

    console.log("categoryQuestionsWithValues", categoryQuestionsWithValues);

    // Calculate total marks from all categories
    const totalMarks = Object.values(categoryQuestionsWithValues).reduce(
      (total, category) =>
        total +
        category.reduce((sum, question) => sum + (question.marks || 0), 0),
      0
    );

    // Form final data object
    const formData = {
      employeeid: id,
      ...categoryQuestionsWithValues, // Spread each category key into the main object
      totalmarks: totalMarks,
      smarkkpi: kpiValues,
      subkpi: subkpiValues,
    };

    // Submit the form data
    setFormData(formData);
    setIsModalOpen(true); // Open the modal or perform other actions
  };

  const updateinitVals = (categoryOptions) => {
    let updatedInitialValues = { ...initialValues };

    categoryOptions.forEach((category) => {
      updatedInitialValues[`questions${category.categoryname}`] =
        category.questions.map((question, qIndex) => ({
          [`questions${category.categoryname}[${qIndex}].question`]:
            question.text || "",
          [`questions${category.categoryname}[${qIndex}].yesno`]: "",
          [`questions${category.categoryname}[${qIndex}].rating`]:
            question.rating || 0,
          [`questions${category.categoryname}[${qIndex}].marks`]: 0,
          [`questions${category.categoryname}[${qIndex}].comments`]: "",
        }));

      setInitialValues(updatedInitialValues);
    });
  };

  useEffect(() => {
    const fetchEmployeeData = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/getemployeemaindetails?uid=` + id
        );
        const data = response.data;
        let arrEmployee = data.employee;
        setEmployee(arrEmployee[0]);
        let gradeid = arrEmployee[0].gradeid;
        console.log(gradeid, "gradeid");
        setGrade(gradeid);
        fetchAppraisalTemplate(gradeid);
        getKPIForuser(arrEmployee[0].employeeid);
        getSubKPI(arrEmployee[0].employeeid);
        setSelectedYear(currentYear);
      } catch (err) {
        console.error("Error fetching team members:", err);
      }
    };
    fetchEmployeeData();
  }, []);

  useEffect(() => {
    setInitialValues({
      category: "",
      subcategory: "",
    });
  }, [options]);

  // Define a function to get the value for each mark field

  const fetchAppraisalTemplate = async (gradeid) => {
    try {
      const response = await axios.get(
        `${baseURL}/gettemplateforappraisa?id=` + gradeid
      );
      const data = response.data;
      if (Array.isArray(data.template)) {
        const { data } = response; // make sure we can get data
        let toJSON = data.template[0].questionsJSON;
        let finaljson = JSON.parse(toJSON);

        setOptions(finaljson.questions);
        setApprQuestionsWeightage(finaljson?.questionsweigtage);
        let kpi = finaljson?.isKpiWeightageIncluded;
        console.log(kpi, "kpi");
        if (kpi) {
          let kpival = finaljson?.kpiweightage;
          setKPIWeightage(kpival);
          setIsKpiWeightageIncluded(kpi);
        } else {
          setIsKpiWeightageIncluded(false);
        }
        const category44Options = finaljson.questions.filter(
          (option) => option.category === "44"
        );
        setAttendanceOptions(category44Options);
        const categoryName =
          category44Options.length > 0
            ? category44Options[0].categoryname
            : null; // Get category name if available
        const escapedCategoryName = categoryName
          ? categoryName.replace("&", "&amp;")
          : null;

        setPrimaryCategoryName(escapedCategoryName);
        console.log("===============");
        console.log(escapedCategoryName);
        console.log("===============");
        const category45Options = finaljson.questions.filter(
          (option) => option.category === "45"
        );
        setPerformanceOptions(category45Options);
        setTotalQuestions(category44Options.length);
        const categoryOtherOptions = finaljson.questions.filter(
          (option) => option.category !== "44" && option.category !== "45"
        );
        setCategoryOptions(categoryOtherOptions);
        const categoryMap = new Map();
        finaljson.questions.forEach((option) => {
          if (!categoryMap.has(option.category)) {
            categoryMap.set(option.category, []);
          }
          categoryMap.get(option.category).push(option);
        });
        //   setCategoryMapvalues(categoryOtherOptions);
        console.log(categoryOtherOptions);
        // setSubcat(finaljson[0].subCategoryQuestions);
        calculateSectionTotals(category45Options);
        const groupedOptions = {};
        finaljson.questions.forEach((option) => {
          const categoryName = option.category;
          // if((categoryName!=="44" && categoryName!=="45"))
          if (!groupedOptions[categoryName]) {
            groupedOptions[categoryName] = [option];
          } else {
            groupedOptions[categoryName].push(option);
          }
        });
        setCategoryMapvalues(groupedOptions);
        updateinitVals(groupedOptions);
      }
    } catch (err) {
      console.error("Error fetching team members:", err);
    }
  };

  const calculateSectionTotals = (perfOptions) => {
    let initialMarks = [];

    let index = 0;
    let opt = "";
    for (let i = 0; i < perfOptions.length; i++)
      initialMarks[i] = perfOptions[i].rating;

    setPefMarks(initialMarks);
    let total = perfOptions.reduce((total, option) => {
      return total + parseInt(option.rating, 10);
    }, 0);
    console.log("subtotal=" + total);
    setSectionTotal(total);
  };

  const setSubtotal = (updatedMarks) => {
    let total = updatedMarks.reduce((total, val) => {
      return total + parseInt(val, 10);
    }, 0);
    console.log("subtotal=" + total);
    return total;
  };

  const calculateCategorySubtotal = (e, values, categoryName, option) => {
    let sum = 0;
    // Object.keys(values).forEach(key => {
    //   if (key.startsWith(`questions${categoryName}`) ) {
    //     let obj = values[key];
    //     let marks = parseFloat(obj[0].marks);
    //     if (marks) {
    //       sum += marks;
    //     }
    //   }
    // });
    let newValue = parseInt(e.target.value, 10);
    if (!isNaN(newValue) && newValue <= option.rating) {
      const sum = calculateCategorySubtotalFromInputs(categoryName);
      //  setFieldValue(`questions${categoryName}.total`, sectionTotal);
      setCaegorytSubtotal[categoryName] = 0;
      setCaegorytSubtotal[categoryName] = sum;

      //   const inputField = document.querySelector(`input[name^="questions${categoryName}"][name$=".marks"]`);
      //   if (inputField) {
      //     inputField.value = e.target.value; // Set the calculated subtotal directly
      //   }
      //   const totalField = document.querySelector(`input[name="questions${categoryName}.total"]`);
      //   if (totalField) {
      //       totalField.value =0;
      //       totalField.value = sum; // Set the calculated subtotal directly
      //   }

      return sum;
    }
  };

  const maxfieldval = (fieldname, maxrating) => {
    const inputField = document.querySelector(`input[name^="${fieldname}"]`);
    if (inputField) {
      inputField.value = maxrating; // Set the calculated subtotal directly
    }
  };
  const calculateCategorySubtotalFromInputs = (categoryName) => {
    let sum = 0;
    // Select all input elements whose name starts with `questions${categoryName}` and ends with `.marks`
    const inputFields = document.querySelectorAll(
      `input[name^="questions${categoryName}"][name$=".marks"]`
    );

    inputFields.forEach((input) => {
      const value = parseInt(input?.value, 10);
      if (!isNaN(value)) {
        sum += value;
      }
    });

    return sum;
  };

  const handleTextareaChange = (e) => {
    let val = e.target.value;
    setTrainingComment(val);
  };
  const handleCommentChange = (e) => {
    let val = e.target.value;
    setGeneralComment(val);
  };

  const calcAllTotal = (values) => {
    let val =
      calculateTotalMarks(values.questions.map((q) => q.marks)) +
      categorySubtotal;
    setTotVal(val);
  };
  // Use totalMarks wherever you need to display the total

  // const handleInputChange = (e, maxValue) => {
  //     const value = e.target.value;
  //     setInputValue(value);
  //     // Check if the input is numeric and less than or equal to the maximum value
  //     if(value.length >1)
  //     if ( parseInt(value) <= maxValue) {
  //       setInputValue(value);
  //       setShowLabel(false);
  //     }
  //     else
  //     {

  //         //setInputValue('');
  //         setShowLabel(true);
  //     }
  //   };

  return (
    <>
      <Dummylayout />
      <BasicCard>
        <div className="container topmiller ">
          <div className="row ">
            <h5>Appraisal Form for </h5>
            <br />
            <br />
            <div className="col-4 ">
              <span className="vfont fs-">Name</span>
              {/* <p className="bfont fs-5 fw-bold">{employee.FirstName?}  {employee.LastName}</p> */}
              <p className="bfont fs-5 fw-bold">
                {`${employee?.FirstName} ${employee?.LastName || ""}`}
              </p>

              <span className="vfont fs">Current Position</span>
              <p className="bfont fs-5 fw-bold">{employee?.designation}</p>
            </div>
            <div className="col-4 ">
              <span className="vfont fs">Employee ID</span>
              <p className="bfont fs-5 fw-bold"> {employee?.employeeid}</p>
              <span className="vfont fs">Grade</span>
              <p className="bfont fs-5 fw-bold">{employee?.gradename}</p>
            </div>
            <div className="col-lg-4 ">
              <img
                className="float-end mx-5"
                width="110"
                alt=""
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAA3NCSVQICAjb4U/gAAAACXBIWXMAAADlAAAA5QGP5Zs8AAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAelQTFRF////JG2SQICAJ05iM1VVNXWAM3CFKUtRM3GCJkdRNHCBJkNNJ0BIMnCAM3GAMnCAJDtBNHKAM3GAIzU5IzY7M3GAM3GAKk1WIi8yM3GAISwwM3GAM3GAICgrHyYoHiIjIiUoFBQUFRUUFhUVFhYWFxYWGRkYHBoYHR0eHR4fHh4fHiEiHiEjHx8gIi8zIjE1IjI2Ix4bIyMlIzU6JCAdJCIgJDY8JyIfJ0VNKEZNKSksKSktKTg5LCciLSsnLychL2JvL2VyMGNvMGVzMGZzMGl2MWp4MWt5MWx6Mm17Mm99MyojMzM5M2BpM3B/M3GANXKAN3KAOGx4OjUvO3SAPXSAPjw2Pj45PmVqPz9HP2ZsQF9iQ0VMQ0VNRUVNRUVORkQ9RkZPR1BMSEhRSUlTSkpUU0EzVldfV1dfWU1AXEc3XE9CXn+AXoCAX2l1YGl2Y4KBZk48a1I/b4J+co2iepOVe3uBe5OVgI+Xh46BjGlPjrDHkm5SmXJVnr/Tn7/TocDUo73Npr/PqcPUqq61r4JgsINhsbK1tMjVxZ98xaOCyKF+0aaB1NbY1qmC2ZRk2qB126J23KJ24KyC4qN55Kh65Onu5Oru5qZ75rWV6qh37Kx+7eLc7qx8769/8bGB8vn+87KB9LOCwa3cagAAACF0Uk5TAAcIDQ8YGSwtL0lQfISXmL/ByNXV2uPu7/Lz8/X5/P7+cDzfRAAAAfxJREFUGBllwYk/FFEcAPDfDrsYZtYsu6wZx+t8uSrddEh3aX8Ula5NTCelSESlKBKr0uEs3l/azHvP7O7H9wtJPjVohE0zbARVH2wW0KPoieoBSKdoFqaxNAVS+EMonb+AUsgPnuwIclfuHSJbjl27jFwkGyR/BLkb+wm3/SZyET9wSgiFq0Q6cAa5kAIuDYVbRNh5iRxFQQNHwELhPnGdePNrlGy7iJwVAAAdpeuEbH3w6R9jnwk5iYIO4IuidJy8/MZcf/fuQCnqAxWltsdPmPTiaRtKKgRR6vs6yqS3X/pQCoKBUm/iO5N+JHpRMiCMUmuCeRKtKIXBxA0980ya78ENJpjoGWZsfXV1nbFh9JgQRk/LNFuam1ti0y3oCYOBSe0zzDHTjkkGBDFF/8Ly8kI/pgiCiile/3S8whQq+KIoxZqG1lYWF1fWhppiKEV9ADq6Th3eXV1jT/weG/szYddU7zlyGl06AAQsxLP7qCveNfvh42xXnDp2HTyHaAXAoWGslnId9uTU1KTdQbnaGGrgUkKNVKjvHBwfH+ysp0JjSAHOX0SFuu6H794/6q6jQpEfpNwyKjTbIyN2MxXKcsGTVUK5yrsDA/FKypVkQYrM/Crqanj2vIG6qvIzIV1OQTl13L5DHeUFObBZRl5hcWlFRWlxYV4GeP4Dm5L5s3KTpvYAAAAASUVORK5CYII="
              />
            </div>
          </div>
        </div>
        <br></br>
        <div className="col-md-8">
          <div className="row">
            <div className="col-md-8">
              <label>Appraisal Year: </label>
              <select
                style={{ "margin-left": "20px" }}
                disabled
                value={appraisalyear}
              >
                <option selected value={appraisalyear}>
                  {appraisalyear}
                </option>
              </select>
            </div>
          </div>
          <br></br>
        </div>
        <h5>Appraisal Questions </h5>
        <h6>Appraisal Questions Weightage Value: {apprQuestionsWeightage}</h6>

        <Formik initialValues={initialValues} onSubmit={handleSubmit}>
          {({
            handleSubmit,
            handleChange,
            values,
            touched,
            errors,
            setFieldValue,
            setValues,
          }) => (
            <form onSubmit={handleSubmit}>
              {categoryMapvalues &&
                Object.entries(categoryMapvalues).map(
                  ([categoryName, categoryOptions], index) => (
                    <div key={index}>
                      <h4>
                        {categoryOptions[0]?.categoryname
                          ? categoryOptions[0]?.categoryname.replace(
                              "&amp;",
                              "&"
                            )
                          : ""}
                      </h4>{" "}
                      {/* Display category name */}
                      <table
                        id={`example${index}`}
                        className="table table-striped w-100 mt-2"
                      >
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Sub-Category Name</th>
                            <th>Question</th>
                            <th>Max Rating</th>
                            <th>Marks</th>
                            <th>Comments</th>
                          </tr>
                        </thead>
                        <tbody>
                          {categoryOptions.map((option, qIndex) => (
                            <tr key={qIndex}>
                              <td>{qIndex + 1}</td>
                              <td>
                                {getSubcategoryName(
                                  categoryName,
                                  option.subcategory
                                )}
                              </td>
                              {/* <td>{option.subcategoryname}</td> */}
                              <td>
                                <Field
                                  as="textarea"
                                  disabled
                                  style={{ border: "none" }}
                                  rows={3}
                                  cols={30}
                                  readOnly={true}
                                  name={`questions${categoryName}[${qIndex}].question`}
                                  value={option.text}
                                />
                              </td>
                              <td>
                                {option.yesNo ? (
                                  <div>
                                    <Field
                                      as="select"
                                      name={`questions${categoryName}[${qIndex}].yesno`}
                                    >
                                      <option value="0">Select Yes/No</option>
                                      <option value="1">Yes</option>
                                      <option value="0">No</option>
                                    </Field>
                                    <Field
                                      type="hidden"
                                      name={`questions${categoryName}[${qIndex}].rating`}
                                    />
                                  </div>
                                ) : (
                                  ((
                                    <Field
                                      type="hidden"
                                      name={`questions${categoryName}[${qIndex}].yesno`}
                                    />
                                  ),
                                  (
                                    <Field
                                      type="text"
                                      className="w-25"
                                      disabled
                                      name={`questions${categoryName}[${qIndex}].rating`}
                                      value={option.rating}
                                    />
                                  ))
                                )}
                                <Field
                                  type="hidden"
                                  name={`questions${categoryName}[${qIndex}]..category`}
                                  value={option.category}
                                />
                                <Field
                                  type="hidden"
                                  name={`questions${categoryName}[${qIndex}].ssubcategory`}
                                  value={option.subcategory}
                                />
                              </td>
                              <td>
                                <Field
                                  type="number"
                                  className="!w-50"
                                  min={0}
                                  onKeyDown={(e) => {
                                    if (e.key === "-" || e.key === "+") {
                                      e.preventDefault();
                                    }
                                  }}
                                  onPaste={(e) => {
                                    const paste =
                                      e.clipboardData.getData("text");
                                    if (paste.includes("-")) {
                                      e.preventDefault();
                                    }
                                  }}
                                  name={`questions${categoryName}[${qIndex}].marks`}
                                  value={option.marks}
                                  max={option.rating}
                                  onChange={(e) => {
                                    let newValue = parseInt(e.target.value, 10);
                                    if (
                                      !isNaN(newValue) &&
                                      newValue <= parseInt(option.rating)
                                    ) {
                                      newValue = Math.max(newValue, 0); // Ensure marks are non-negative
                                      // Update the state with the new marks value
                                      setFieldValue(
                                        `questions${categoryName}[${qIndex}].marks`,
                                        newValue
                                      );
                                      // Calculate and update the section total
                                      const updatedMarks = [...catmarks]; // Copy the current state array
                                      updatedMarks[qIndex] = newValue; // Update the value at the corresponding index
                                      setCatmarks(updatedMarks);
                                      const sectionTotal =
                                        calculateCategorySubtotal(
                                          e,
                                          values,
                                          categoryName,
                                          option
                                        );
                                      // setFieldValue(`questions${categoryName}.total`, sectionTotal+newValue);
                                      console.log(
                                        "sectionTotal" + setFieldValue
                                      );
                                      const totalField = document.querySelector(
                                        `input[name="questions${categoryName}.total"]`
                                      );
                                      if (totalField) {
                                        totalField.value = 0;
                                        totalField.value = sectionTotal; // Set the calculated subtotal directly
                                      }
                                    } else if (
                                      newValue > parseInt(option.rating)
                                    ) {
                                      let maxval = option.rating;

                                      const updatedMarks = [...catmarks]; // Copy the current state array
                                      updatedMarks[qIndex] = maxval; // Update the value at the corresponding index
                                      setCatmarks(updatedMarks);

                                      // alert("Marks cannot exceed " + option.rating)
                                      //  setMaxMarks(option.rating);
                                      setFieldValue(
                                        `questions${categoryName}[${qIndex}].marks`,
                                        maxval
                                      );
                                      setTimeout(
                                        () =>
                                          alert(
                                            "Marks cannot exceed " +
                                              option.rating
                                          ),
                                        1000
                                      );

                                      maxfieldval(
                                        `questions${categoryName}[${qIndex}].marks`,
                                        maxval
                                      );
                                      const sectionTotal1 =
                                        calculateCategorySubtotal(
                                          e,
                                          values,
                                          categoryName,
                                          option
                                        );
                                      const totalField1 =
                                        document.querySelector(
                                          `input[name="questions${categoryName}.total"]`
                                        );

                                      if (totalField1) {
                                        totalField1.value = 0;
                                        totalField1.value = sectionTotal1; // Set the calculated subtotal directly
                                      }
                                    }
                                  }}
                                  onWheel={(e) => e.target.blur()}
                                />
                              </td>
                              <td>
                                <Field
                                  as="textarea"
                                  name={`questions${categoryName}[${qIndex}].comments`}
                                  cols={33}
                                />
                              </td>
                            </tr>
                          ))}
                          <td
                            colSpan="6"
                            className="text-end mx-1 text-dark fw-bold"
                          >
                            Section Total
                            <Field
                              type="number"
                              disabled
                              className="float-end mx-2"
                              name={`questions${categoryName}.total`}
                              value={categorySubtotal[categoryName]}
                              readOnly
                            />
                          </td>
                        </tbody>
                      </table>
                    </div>
                  )
                )}

              <table className="w-100">
                <tbody>
                  <tr>
                    <td
                      colspan="12"
                      className="text-end mx-1 text-dark fw-bold"
                    >
                      {" "}
                      Appraisal Questions Total Marks
                      <Field
                        type="number"
                        className="float-end mx-2 "
                        name={`total`}
                        value={calculateFinalTotal()}
                        readOnly={true}
                      />{" "}
                    </td>
                  </tr>
                </tbody>
              </table>
              {warningText ? (
                <h6 className="w-75 border border-danger text-danger pt-1 pb-1 text-center m-auto mt-3">
                  {" "}
                  {warningText}{" "}
                </h6>
              ) : (
                ""
              )}
              <br></br>

              {/*
-------------------------KPI Appraisal Integration Table----------------------- */}
              {isKpiWeightageIncluded && isKpiWeightageIncluded === true ? (
                <>
                  <h5>KPI </h5>
                  <h6>KPI Weightage Value: {KPIWeightage}</h6>
                  <div className="bg-danger">
                    <ReactBootstrap.Table
                      striped
                      bordered
                      hover
                      size="sm"
                      className="bg-danger"
                    >
                      <thead className="text-center">
                        <tr>
                          <th>#</th>
                          <th>KPI</th>
                          <th nowrap>Start Date</th>
                          <th>End Date</th>
                          <th>Department</th>

                          <th>Progress</th>
                          <th>Action</th>
                        </tr>
                      </thead>

                      <tbody>
                        {posts.smartgoals.length === 0 ? (
                          <tr>
                            <td colSpan="8" className="text-center">
                              No data
                            </td>
                          </tr>
                        ) : (
                          ""
                        )}
                        {posts.smartgoals.map((smartgoal, index) => (
                          <React.Fragment key={index}>
                            <tr className="w-100">
                              <td>{index + 1}</td>
                              <td>{smartgoal.title}</td>
                              <td>{formatDate(smartgoal.startdate)}</td>
                              <td>{formatDate(smartgoal.enddate)}</td>
                              <td>{smartgoal.departmentname}</td>
                              <td hidden>{smartgoal.assigneeids}</td>
                              <td>
                                <ProgressBar
                                  variant={getProgressColor(smartgoal.progress)}
                                  now={smartgoal.progress}
                                />
                              </td>
                              <td className="col-1">
                                <input
                                  type="number"
                                  max={KPIWeightage}
                                  name={`smartgoals[${index}].marks`}
                                  onChange={(e) =>
                                    handleKPIChange(e, smartgoal.id)
                                  }
                                  // value={
                                  //   kpiOptions.find(
                                  //     (kpi) => kpi.id === smartgoal.id
                                  //   )?.val || ""
                                  // }
                                  value={
                                    kpiOptions.find(
                                      (kpi) => kpi.id === smartgoal.id
                                    )?.val ?? 0
                                  }
                                  className="w-100"
                                ></input>
                              </td>
                              {/* Action buttons */}
                            </tr>
                          </React.Fragment>
                        ))}
                      </tbody>
                    </ReactBootstrap.Table>
                  </div>

                  <h5>Sub KPI</h5>
                  <div className="">
                    <table className="w-100  bg-white">
                      <thead className="text-center">
                        <tr className="tableheading">
                          <th>#</th>
                          <th>Sub KPI</th>
                          <th>Description</th>
                          <th>Start Date</th>
                          <th>End Date</th>
                          <th>Progress</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {postsSub.subgoals.map((subgoals, index) => (
                          <tr className="text-left" key={index}>
                            <td className="col-1">{subgoals.id}</td>
                            <td className="col-2">{subgoals.title}</td>
                            <td className="col-3">{subgoals.description}</td>
                            <td className="col-1" nowrap>
                              {formatDate(subgoals.startdate)}
                            </td>
                            <td className="col-1" nowrap>
                              {formatDate(subgoals.enddate)}
                            </td>
                            {/* <td>{smartgoal.designationid}</td>
                            <td>{smartgoal.assignees}</td> */}
                            <td className="col-1">
                              <ProgressBar
                                variant={getProgressColor(subgoals.progress)}
                                now={subgoals.progress}
                              />
                            </td>
                            <td className="col-1">
                              <input
                                name={`subgoals[${index}].marks`}
                                onChange={(e) =>
                                  handleSubKPIChange(e, subgoals.id)
                                }
                                type="number"
                                max={KPIWeightage}
                                className="w-100 pl-3"
                              ></input>
                            </td>
                            {/* Action buttons */}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <br></br>
                </>
              ) : null}

              <table width="100%">
                <tr>
                  <td className="w-75 text-end   text-dark fw-bold">
                    <b>KPI Total Marks</b>
                  </td>
                  <td>
                    <Field
                      type="number"
                      disabled
                      className="float-end mx-2 "
                      name="kpitotal"
                      value={smartKPITotal + subKPITotal || 0}
                      readOnly={true}
                    />
                  </td>
                </tr>
              </table>
              <br></br>
              <table width="100%">
                <tr>
                  <td className="w-75 text-end   text-dark fw-bold">
                    <b> Total Marks</b>
                  </td>
                  <td>
                    <Field
                      type="number"
                      disabled
                      className="float-end mx-2 "
                      name="appraisalTotal"
                      value={
                        subKPITotal + smartKPITotal + calculateFinalTotal()
                      }
                      readOnly={true}
                    />
                  </td>
                </tr>
              </table>
              <table className="w-100">
                <tbody>
                  <tr>
                    <td className="col-lg-12">
                      {" "}
                      <h4>Personal Development Plan</h4>
                      <p>
                        Assessor to comment on any training, educational
                        requirement that would benefit the employee
                      </p>
                      <textarea
                        rows="8"
                        cols="110"
                        className="w-100"
                        value={trainingComment}
                        onChange={handleTextareaChange}
                      ></textarea>{" "}
                    </td>{" "}
                  </tr>
                  <tr>
                    <td
                      colspan="12"
                      className="text-start mx-1 text-dark fw-bold"
                    >
                      <div className="d-flex pb-3">
                        {" "}
                        <div className="col-lg-6"> ASSESSOR: {username} </div>
                        <div className="col-lg-6 text-end">
                          {" "}
                          DATE: {currentDate}
                        </div>
                      </div>
                      <h6>Comments</h6>
                      <textarea
                        rows="8"
                        cols="110"
                        className="w-100"
                        value={generalComment}
                        onChange={handleCommentChange}
                      ></textarea>
                      <br></br>
                      <h3 className="mt-3">Declaration</h3>
                      I hearby declare that is to the best of my knowledge, and
                      reflects the fact about employees performance and I take
                      responsibility for any misleading information.
                      <br /> <br />{" "}
                      <input
                        type="checkbox"
                        disabled={approval && approval === "Approved"}
                        checked={approval && approval === "Approved"}
                      />{" "}
                      &nbsp; Confirm
                    </td>
                  </tr>{" "}
                  {approvalDate ? (
                    <div>
                      <label htmlFor="approvalDate">Approved Date:</label>
                      <input
                        type="text"
                        id="approvalDate"
                        value={approvalDate}
                        className="w-75 p-75"
                        readOnly // to make it read-only
                      />
                    </div>
                  ) : null}
                  {appeallDate ? (
                    <div>
                      <label htmlFor="applealdate f18">
                        Appeal Requested Date:
                      </label>
                      <input
                        type="text"
                        id="approvalDate"
                        value={appeallDate}
                        className="w-75 p-75 border-0 fw-bold f6"
                        readOnly // to make it read-only
                      />
                    </div>
                  ) : null}
                </tbody>
              </table>

              <div className="col-lg-11 text-end mt-4 pb-3">
                <Button
                  className="border-0 mt-2 p-1 btn-#8d3523 savebtn"
                  type="submit"
                >
                  Save
                </Button>
                <a href="#" className="text-decoration-none ">
                  <button
                    type="button"
                    className="btn cancelbtn ml-2"
                    onClick={() => setIsModalOpen(false)}
                  >
                    Cancel
                  </button>
                </a>
              </div>
            </form>
          )}
        </Formik>

        <Modal show={isModalOpen} onHide={() => setIsModalOpen(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Submission</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to submit this appraisal?
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-primary" onClick={handleConfirm}>
              Confirm
            </button>
            <button
              className="btn btn-secondary"
              onClick={() => setIsModalOpen(false)}
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>

        {/* <Modal show={ispipModelOpen} onHide={() => setpipModalOpen(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>PIP Apply</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Mark is Below 65% Do you apply for PIP
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-primary" onClick={handlePIPConfirm}>Ok</button>
                        <button className="btn btn-secondary" onClick={() => setIsModalOpen(false)}>Cancel</button>

                    </Modal.Footer>
                </Modal> */}
        <div>
          <ToastContainer position="bottom-end" className="p-3">
            <Toast
              onClose={() => setShowToast(false)}
              show={showToast}
              delay={3000}
              autohide
              className="bg-success text-white"
            >
              <Toast.Header>
                <span className="me-2">✔️</span> {/* Unicode tick mark */}
                <strong className="me-auto">Notification</strong>
              </Toast.Header>
              <Toast.Body>Success!, data updated successfully!</Toast.Body>
            </Toast>
          </ToastContainer>
        </div>
      </BasicCard>
    </>
  );
}

export default AppraisalTeamMember;
